/* eslint-disable */
import dicts from './example'

// 支部规章制度-表单
export const branchSchemeForm = {
    attrs: {
        labelWidth: '180px',
        'label-position': 'left',
        rules: {
            orgType: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
            name: [
                {
                    required: true,
                    message: '请输入',
                    trigger: 'blur',
                },
            ],
            schemeType: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
            fileUrl: [
                {
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                },
            ],
        },
    },
    items: [
        {
            label: '规章制度名称',
            prop: 'name',
            maxlength: 100,
            showWordLimit: true,
            clearable: true,
        },
        {
            type: 'select',
            label: '规章制度制定单位',
            prop: 'orgType',
            options: dicts.orgType(),
        },
        {
            type: 'select',
            label: '规章制度类别',
            prop: 'schemeType',
            options: dicts.schemeType(),
        },
        {
            type: 'file-upload',
            label: '规章制度文档',
            prop: 'fileUrl',
        },
        {
            type: 'radio',
            label: '是否推荐至数字驾驶舱-制度建设创新制度',
            prop: 'isRecomment',
            initValue: 1,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
            attrs: {
                'label-width': '300px'
            }
        }
    ],
}

// 支部规章制度-表格
export const branchSchemeCols = [
    {
        title: '规章制度名称',
        key: 'name',
        tooltip: true,
        minWidth: 150,
    },
    {
        title: '规章制度制定单位',
        slot: 'orgType',
        tooltip: true,
        width: 160,
    },
    {
        title: '规章制度类别',
        slot: 'schemeType',
        tooltip: true,
        width: 160,
    },
    {
        title: '规章制度文档',
        slot: 'fileUrl',
        tooltip: true,
        width: 300,
    },
    {
        title: '是否推荐至数字驾驶舱',
        slot: 'isRecomment',
        width: 200,
    },
    {
        title: '操作',
        slot: 'operation',
        width: 160,
        fixed: 'right',
        align: 'center'
    }
]
